import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VehicleState } from 'src/app/models/vehicleState';
import { ApiDataService } from 'src/app/shared/services/api.data.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleDetailService {


  constructor(private api: ApiDataService) {
  }

  getVehicleStateByVin(vin: string): Observable<any> {
    const url = this.api.buildUrl(`vehiclestate/vin/${vin}`);
    return this.api.get(url);
  }

  postVehicleState(vehicleState: VehicleState): Observable<any> {
    const url = this.api.buildUrl(`vehicleState`);
    return this.api.post(url, vehicleState);
  }

  postVehicleParts(parts: any): Observable<any> {
    const url = this.api.buildUrl(`vehiclePart/multi`);
    return this.api.post(url, parts);
  }

  getVehicleGroups(vin: string): Observable<any> {
    const url = this.api.buildUrl(`vehicleGroup/vin/${vin}`);
    return this.api.get(url);
  }

  removeVehicleParts(parts: any): Observable<any> {
    const url = this.api.buildUrl(`vehiclePart`);
    return this.api.delete(url, parts);
  }

  
}
